import { ClearInputIcon, SearchIcon } from '@/shared/ui/Icons'
import { useSearchStore } from '@/shared/store/useSearchStore'
import { Box, IconButton } from '@mui/material'
import React from 'react'

const SearchBarIcons = () => {
    const { searchValue, setSearchValue } = useSearchStore()
    const searchIconStyle = {
        position: 'relative',
        top: 2,
        right: 4,
    }

    const clearIconStyle = {
        position: 'relative',
        top: 0,
        left: 3,
    }

    const handleInputClear = () => {
        setSearchValue('')
    }
    return (
        <Box>
            {searchValue.length ? (
                <IconButton sx={clearIconStyle} onClick={handleInputClear}>
                    <ClearInputIcon data-testid="clear-icon" />
                </IconButton>
            ) : (
                <Box sx={searchIconStyle}>
                    <SearchIcon data-testid="search-icon" />
                </Box>
            )}
        </Box>
    )
}

export default SearchBarIcons
